module.exports = __webpack_public_path__ + "static/media/product-image-1.2508e525.jpg";